<template>
  <div class="profile">
    <div class="profile__header">
      <div
        class="profile__image"
        v-if="fields && fields.image.value.src && fields.image.value.src.length > 0"
      >
        <sc-image v-if="fields && fields.image" :media="fields.image" />
      </div>
      <div class="profile__info">
        <sc-text tag="h1" class="name" v-if="fields && fields.name" :field="fields.name" />
        <sc-text tag="h3" class="company" v-if="fields && fields.company" :field="fields.company" />
        <sc-text tag="h5" class="title" v-if="fields && fields.title" :field="fields.title" />
      </div>
    </div>
    <sc-rich-text
      class="profile__content"
      v-if="fields && fields.content"
      :field="fields.content"
    />
  </div>
</template>

<script>
import { Image, Text, RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Profile',
  components: {
    ScText: Text,
    ScImage: Image,
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.profile {
  &__header {
    text-align: center;

    @include desktop-up {
      display: flex;
      text-align: left;
    }
  }

  &__image {
    @include desktop-up {
      margin-right: 5.5rem;
    }

    img {
      width: 23rem;
      height: auto;
    }
  }

  &__info {
    width: 100%;

    .name {
      @include font-styles('Arial', 3.6rem, 200, normal, 4.2rem, 0, $blue);
      padding-bottom: 1rem;
      margin-top: 2rem;
      margin-bottom: 1.2rem;
      border-bottom: 0.1rem solid $divider;

      @include desktop-up {
        font-size: 5rem;
        line-height: 6.5rem;
        padding-bottom: 2rem;
      }
    }

    .company {
      @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $blue);
      margin-bottom: 0.8rem;

      @include desktop-up {
        font-size: 2.8rem;
        line-height: 3.5rem;
        margin-bottom: 1.2rem;
      }
    }

    .title {
      @include font-styles('Arial', 1.6rem, 500, normal, 2.2rem, 0, $dark-blue);
      margin-bottom: 0.8rem;

      @include desktop-up {
        font-size: 2rem;
        line-height: 2.6rem;
        margin-bottom: 1.2rem;
      }
    }
  }

  &__content {
    margin-top: 4rem;
  }
}
</style>
